import React, { useState, useEffect, memo } from 'react';
import { withFocus } from '@accedo/vdkweb-navigation';
import { RoundButton } from '#/components/RoundButton/RoundButton';
import ImageWithPreload from '#/components/ImageWithPreload/ImageWithPreload';
import { ITEM_TYPES } from '#/config/constants';
import Nav from '#/interfaces/Nav';
import { getTranslation } from '#/services/i18n';
import getImageByType from '#/utils/getImageByType';
import style from './heroItem.scss';

interface HeroItem {
  data: any; // "any" until we review the data structure.
  nav: Nav;
  onClick: () => any | void;
  buttonText: string;
  width: number | string;
  height: number | string;
}

const HeroItem = ({
  onClick,
  nav,
  data,
  buttonText: buttonTextProp,
  width: widthProp,
  height: heightProp
}: HeroItem) => {
  const [width] = useState(widthProp);
  const [height] = useState(heightProp);
  const [buttonText, setButtonText] = useState(buttonTextProp);
  const [poster, setPoster] = useState('');

  const loadImage = () => {
    if (!data.images?.length) {
      return;
    }
    const image = getImageByType(data.images, ITEM_TYPES.HeroBanner);
    setPoster(image);
  };

  const loadButtonTranslation = async () => {
    if (buttonText) {
      return;
    }

    const translation = await getTranslation('moreDetails');
    setButtonText(translation);
  };

  useEffect(() => {
    loadImage();
    loadButtonTranslation();
  }, []);

  const backgroundClassName = `${style.background} ${
    nav.isFocused ? style.backgroundFocused : ''
  }`;

  return (
    <div style={{ width, height }}>
      <div
        className={backgroundClassName}
        onMouseOver={nav.onMouseOver}
        onMouseOut={nav.onMouseOut}
      >
        <img src={poster} alt="Hero" />
        <div className={style.contentContainer}>
          <div className={style.title}>{data.displayText || data.title}</div>
          <RoundButton
            className={style.button}
            onClick={onClick}
            displayText={buttonText}
            nav={nav}
          />
        </div>
      </div>
    </div>
  );
};

const propsAreEqual = (prevProps: HeroItem, nextProps: HeroItem) => {
  const { data: prevData, nav: prevNav, buttonText: prevButtonText } =
    prevProps || {};
  const { data: nextData, nav: nextNav, buttonText: nextButtonText } =
    nextProps || {};

  return (
    prevButtonText === nextButtonText &&
    prevData.id === nextData.id &&
    prevNav.isFocused === nextNav.isFocused &&
    prevNav.nextleft === nextNav.nextleft &&
    prevNav.nextright === nextNav.nextright
  );
};

export default memo(withFocus(HeroItem), propsAreEqual);
